import { gql } from "@apollo/client"

export const VerificationStatusFields = gql`
  fragment VerificationStatusFields on KycVerification {
    id
    status
    sessionId
    sessionUrl
    updatedAt
  }
`
